/**
 * General Settings Page
 */
import React from 'react';

const GeneralSettings = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">General Settings</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Configure general system settings</p>
    </div>
  );
};

export default GeneralSettings;
